import { mapActions } from 'vuex'
import { wait } from '@modules/time'

export default {
  beforeRouteUpdate (to, from, next) {
    this.updateTransition('in')
    wait(1000, () => {
      next()
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      wait(500, () => {
        vm.updateTransition('out')
      })
    })
  },
  beforeRouteLeave (to, from, next) {
    this.updateTransition('in')
    wait(1000, () => {
      this.$scrollTo('body')
      next()
    })
  },
  methods: {
    ...mapActions({
      updateTransition: 'page/updateTransition'
    })
  }
}
